interface User {
  id?: number;
  name?: string;
  email?: string;
  phoneNumber?: string;
  phone?: string;
  postalCode?: string;
  postal_code?: string;
  pincode?: string;
  state?: string;
  district?: string;
  blockTehsil?: string;
  block_tehsil?: string;
  panCardNo?: string;
  pan_card_no?: string;
  donorType?: string;
  donor_type?: string;
}

const REQUIRED_DONATION_FIELDS = [
  'name',
  'email',
  'phoneNumber',
  'postalCode',
  'state',
  'district',
  'panCardNo',
] as const;

export function isProfileCompleteForDonation(user: User | null): {
  isComplete: boolean;
  missingFields: string[];
} {
  if (!user) {
    return {
      isComplete: false,
      missingFields: REQUIRED_DONATION_FIELDS.map(f => formatFieldName(f)),
    };
  }

  const missingFields: string[] = [];

  if (!user.name || user.name.trim() === '') {
    missingFields.push('Full Name');
  }

  if (!user.email || user.email.trim() === '') {
    missingFields.push('Email');
  }

  const phone = (user.phoneNumber || user.phone || '').trim();
  if (!phone) {
    missingFields.push('Phone Number');
  } else if (phone.replace(/\D/g, '').length < 7) {
    missingFields.push('Phone Number (invalid format)');
  }

  const donorType = (user.donorType || user.donor_type || '').toUpperCase();
  const isNriOrOrg = donorType === 'NRI' || donorType === 'ORGANIZATION';

  const postalCode = (user.postalCode || user.postal_code || user.pincode || '').trim();
  if (!postalCode) {
    missingFields.push('Postal Code');
  } else if (!isNriOrOrg && !/^\d{6}$/.test(postalCode)) {
    missingFields.push('Postal Code (must be 6-digit pincode)');
  }

  if (!user.state || user.state.trim() === '') {
    missingFields.push('State');
  }

  if (!user.district || user.district.trim() === '') {
    missingFields.push('District');
  }

  const pan = (user.panCardNo || user.pan_card_no || '').trim();
  if (!isNriOrOrg) {
    if (!pan) {
      missingFields.push('PAN Card Number');
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/i.test(pan)) {
      missingFields.push('PAN Card Number (invalid format — expected ABCDE1234F)');
    }
  }

  if (!donorType) {
    missingFields.push('Donor Type (KYC)');
  }

  return {
    isComplete: missingFields.length === 0,
    missingFields,
  };
}

function formatFieldName(field: string): string {
  const fieldMap: Record<string, string> = {
    name: 'Full Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    postalCode: 'Postal Code',
    state: 'State',
    district: 'District',
    panCardNo: 'PAN Card Number',
  };

  return fieldMap[field] || field;
}
